import { render, staticRenderFns } from "./help.vue?vue&type=template&id=8fbfd88a&scoped=true&"
import script from "./help.vue?vue&type=script&lang=js&"
export * from "./help.vue?vue&type=script&lang=js&"
import style0 from "./help.vue?vue&type=style&index=0&id=8fbfd88a&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fbfd88a",
  null
  
)

export default component.exports